import { formatCount } from '@/shared/lib/datetime';
import { IconButton } from '@/shared/ui/IconButton';
import { ChevronLeftIcon, ChevronRightIcon, ChevronsLeftIcon, ChevronsRightIcon } from '@/shared/ui/icons';

interface PaginationProps {
  page: number;
  totalPages: number;
  range: { from: number; to: number };
  totalRecords: number;
  disabled: boolean;
  onChange: (page: number) => void;
}

export function Pagination({ page, totalPages, range, totalRecords, disabled, onChange }: PaginationProps) {
  const isFirst = page <= 1;
  const isLast = page >= totalPages;

  return (
    <>
      <p className="tabular text-[0.8125rem] text-ink-muted" aria-live="polite">
        {totalRecords === 0 ? (
          'Nenhum registro'
        ) : (
          <>
            <span className="font-medium text-ink">
              {formatCount(range.from)}–{formatCount(range.to)}
            </span>{' '}
            de {formatCount(totalRecords)}
          </>
        )}
      </p>

      <nav aria-label="Paginação" className="flex items-center gap-1.5">
        <IconButton label="Primeira página" icon={<ChevronsLeftIcon />} disabled={disabled || isFirst} onClick={() => onChange(1)} />
        <IconButton label="Página anterior" icon={<ChevronLeftIcon />} disabled={disabled || isFirst} onClick={() => onChange(page - 1)} />

        <span className="tabular px-2 text-[0.8125rem] text-ink-muted">
          {formatCount(page)} <span className="text-ink-subtle">/ {formatCount(totalPages)}</span>
        </span>

        <IconButton label="Próxima página" icon={<ChevronRightIcon />} disabled={disabled || isLast} onClick={() => onChange(page + 1)} />
        <IconButton label="Última página" icon={<ChevronsRightIcon />} disabled={disabled || isLast} onClick={() => onChange(totalPages)} />
      </nav>
    </>
  );
}
